import Transfer from 'antd/lib/transfer';
import './index.less';

export default Transfer;



// WEBPACK FOOTER //
// ./src/elements/transfer/index.js